import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/site";

// Accessible FAQ accordion (Radix) with huge editorial type and a plus icon
// that rotates to a minus on open. 1px dividers.
export default function FaqAccordion({ items = FAQS, className = "" }) {
  return (
    <Accordion.Root
      type="single"
      collapsible
      className={`border-t border-brand-ink/15 ${className}`}
      data-testid="faq-accordion"
    >
      {items.map((item, i) => (
        <Accordion.Item
          key={i}
          value={`item-${i}`}
          className="border-b border-brand-ink/15 group"
        >
          <Accordion.Header>
            <Accordion.Trigger
              className="flex w-full items-center justify-between gap-6 py-6 md:py-8 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-red rounded-sm"
              data-testid={`faq-trigger-${i}`}
            >
              <span className="font-display text-xl md:text-3xl text-brand-ink transition-colors group-hover:text-brand-red">
                {item.q}
              </span>
              <Plus
                size={26}
                className="shrink-0 text-brand-red transition-transform duration-300 group-data-[state=open]:rotate-45"
              />
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
            <p className="pb-8 pr-10 max-w-2xl text-base md:text-lg leading-relaxed text-muted-foreground">
              {item.a}
            </p>
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
}
